import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'classnames';
import React__default from 'react';
import InputCheckbox from './Checkbox.js';
import InputCheckboxes from './Checkboxes.js';
import InputChip from './Chip.js';
import InputChips from './Chips.js';
import InputColor from './Color.js';
import InputCurrency from './Currency.js';
import InputDate from './Date.js';
import InputDatetimeLocal from './DatetimeLocal.js';
import { InputDropArea } from './DropArea.js';
import InputDropWindow from './DropWindow.js';
import InputEmail from './Email.js';
import InputFeedback from './Feedback.js';
import InputIconToggle from './IconToggle.js';
import InputInfo from './Info.js';
import InputLabel from './Label.js';
import InputMonth from './Month.js';
import InputNumber from './Number.js';
import InputPassword from './Password.js';
import InputRadio from './Radio.js';
import InputRange from './Range.js';
import InputRating from './Rating.js';
import InputSelect from './Select.js';
import SingleRadio from './SingleRadio.js';
import InputTelephone from './Telephone.js';
import InputText from './Text.js';
import FormTextarea from './Textarea.js';
import InputTime from './Time.js';
import InputToggle from './Toggle.js';
import InputUrl from './Url.js';
import InputWeek from './Week.js';

var _excluded = ["className"];

// INPUT PARENT - this is not used for anything other than to attach all input types
var Input = function Input(_ref) {
  _ref.className;
    var otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", otherProps);
};
Input.displayName = 'Input';
Input.Checkbox = InputCheckbox;
Input.Checkboxes = InputCheckboxes;
Input.Chip = InputChip;
Input.Chips = InputChips;
Input.Color = InputColor;
Input.Currency = InputCurrency;
Input.Date = InputDate;
Input.DatetimeLocal = InputDatetimeLocal;
Input.DropArea = InputDropArea;
Input.DropWindow = InputDropWindow;
Input.Email = InputEmail;
Input.Feedback = InputFeedback;
Input.IconToggle = InputIconToggle;
Input.Info = InputInfo;
Input.Label = InputLabel;
Input.Month = InputMonth;
Input.Number = InputNumber;
Input.Password = InputPassword;
Input.Radio = InputRadio;
Input.SingleRadio = SingleRadio;
Input.Range = InputRange;
Input.Rating = InputRating;
Input.Select = InputSelect;
Input.Telephone = InputTelephone;
Input.Text = InputText;
Input.Textarea = FormTextarea;
Input.Time = InputTime;
Input.Toggle = InputToggle;
Input.Url = InputUrl;
Input.Week = InputWeek;

export { Input as default };
